export default "__VITE_ASSET__DmEaT9JU__"